import { render, staticRenderFns } from "./OpenAPIView.vue?vue&type=template&id=56dcf837&"
import script from "./OpenAPIView.vue?vue&type=script&lang=ts&"
export * from "./OpenAPIView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports